import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { calculateTax } from './TaxCalculator';
import { amountInWords } from './amountInWords';

export const GrandTotalsWatcher = () => {
    const { setValue } = useFormContext();
    
    const formValues = useWatch() || {};
    
    const items = useWatch({ name: 'items' }) || [];
    const lrAmount = Number(useWatch({ name: 'lr_amount' })) || 0;
    // igst_amount is manual-entry only — not computed here
    const manualIgst = Number(useWatch({ name: 'igst_amount' })) || 0;

    const itemsStr = JSON.stringify(items);

    useEffect(() => {
        if (!items || !Array.isArray(items)) return;

        let totalAmount = 0;
        let totalCgst = 0;
        let totalSgst = 0;
        let totalTax = 0;
        let subtotal = 0;

        items.forEach((item: any) => {
            const qty = Number(item.quantity) || 0;
            const price = Number(item.unit_price) || 0;
            const rate = Number(item.tax_rate) || 0;
            const amount = qty * price;

            const tax = calculateTax({ amount, taxRate: rate });

            totalCgst += tax.cgst;
            totalSgst += tax.sgst;
            totalTax += tax.totalTax;
            subtotal += amount;
            totalAmount += (amount + tax.totalTax);
        });

        // Add LR Freight and manual IGST to grand total
        totalAmount += lrAmount + manualIgst;

        // Rounding to 2 decimal places to avoid float issues
        const newSubtotal = Math.round(subtotal * 100) / 100;
        const newTaxAmount = Math.round((totalTax + manualIgst) * 100) / 100;
        const newCgst = Math.round(totalCgst * 100) / 100;
        const newSgst = Math.round(totalSgst * 100) / 100;
        const newTotal = Math.round(totalAmount * 100) / 100;
        const newWords = amountInWords(newTotal);

        // ONLY update if values ACTUALLY changed to prevent infinite loops
        if (formValues.subtotal !== newSubtotal) setValue('subtotal', newSubtotal, { shouldDirty: true });
        if (formValues.tax_amount !== newTaxAmount) setValue('tax_amount', newTaxAmount, { shouldDirty: true });
        if (formValues.cgst_amount !== newCgst) setValue('cgst_amount', newCgst, { shouldDirty: true });
        if (formValues.sgst_amount !== newSgst) setValue('sgst_amount', newSgst, { shouldDirty: true });
        if (formValues.total_amount !== newTotal) setValue('total_amount', newTotal, { shouldDirty: true });
        if (formValues.amount_in_words !== newWords) setValue('amount_in_words', newWords, { shouldDirty: true });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsStr, lrAmount, manualIgst, setValue]);

    return null;
};
